// O nome legivel de uma ferramenta (D13): a traducao `analyticsTool.<nome>`, com a variante das encomendas
// (item 8) no `order_inquiry_tool`. Sem traducao o `translate` devolve a propria chave, e mostra-se o
// nome como veio.
export const toolLabel = (name, ordersVariant, translate) => {
  const key = name === "order_inquiry_tool" ? `analyticsTool.${name}.${ordersVariant}` : `analyticsTool.${name}`;
  const label = translate(key);
  return label === key ? name : label;
};
